export enum ModalContainerSize {
    Small = "w-80",
    Medium = "w-[320px]",
    Large = "w-[418px]",
    XLarge = "w-[692px]",
    XXLarge = "w-256",
}

export enum ModalContainerPosition {
    Bottom = "justify-end",
    Center = "justify-center",
    Top = "justify-start",
}

export enum OverlayModalType {
    General = "general-modal",
    Bottom = "bottom-modal",
}
